import React, { useState, useEffect } from "react";
import { useTranslation, Trans } from "react-i18next";
import { useResponsive } from "hooks/useResponsive";
import { useNavigate } from "react-router-dom";

// Routes
import paths from "routes/paths";

// Components
import { SocialButtons } from "pages/Login/SocialButtons";
import { SignInForm } from "pages/Login/SignInForm";
import { Divider, VerticalDivider } from "components/spocketUI/";
import { default as Loadable } from "components/_Shared/commonLoadable";
import { CaptchaDisclaimer } from "components/CaptchaDisclaimer";
import { TopContainerLogin } from "components/TopContainerLogin";

// Style
import "../../index.css"; // TODO We need to change our base CSS to remove bloat and use Styled-Components
import {
  SigninContainer,
  ContentContainer,
  IntroTextContainer,
  IntroTextBold,
  IntroText,
  FormContainer,
  StyledLink,
  HorizontalDividerContainer,
  VerticalDividerContainer
} from "./Login.style";

export const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const { isPhone } = useResponsive();
  const [isFormActive, setIsFormActive] = useState(false);

  useEffect(() => {
    document.title = t("Login.PageTitle");
    const hasOpenModalOnUrl = window.location.search.includes("open-forgot-password-modal");
    if (hasOpenModalOnUrl) {
      navigate(paths.auth.forgotPassword);
    }
  }, []);

  return (
    <Loadable active={isLoading} spinnerSize="10px">
      <SigninContainer>
        <TopContainerLogin />
        <ContentContainer>
          <IntroTextContainer>
            <IntroTextBold>{t("Login.SigninForm.IntroTextBold")}</IntroTextBold>
            <IntroText>
              <Trans
                i18nKey="Login.SigninForm.IntroText"
                components={{
                  1: <StyledLink to={paths.auth.signup} />
                }}
              />
            </IntroText>
          </IntroTextContainer>

          <FormContainer isFormActive={isFormActive}>
            <SignInForm
              setIsLoading={setIsLoading}
              isFormActive={isFormActive}
              isPhone={isPhone}
              onFocusForm={() => setIsFormActive(true)}
            />
            {isPhone && !isFormActive ? (
              <HorizontalDividerContainer>
                <Divider>{t("Login.Divider.Mobile")}</Divider>
              </HorizontalDividerContainer>
            ) : (
              <VerticalDividerContainer>
                <VerticalDivider>{t("Login.Divider")}</VerticalDivider>
              </VerticalDividerContainer>
            )}

            <SocialButtons isFormActive={isFormActive} isPhone={isPhone} />
          </FormContainer>
          <CaptchaDisclaimer isFormActive={isFormActive} />
        </ContentContainer>
      </SigninContainer>
    </Loadable>
  );
};
